import { createFileRoute } from "@tanstack/react-router";
import { RingGameRecordsPage } from "@/features/admin/ring-game-records/ring-game-records-page";

export const Route = createFileRoute("/admin/ring-game-records")({
  component: RouteComponent,
  ssr: false,
});

function RouteComponent() {
  return <RingGameRecordsPage />;
}
